export default "__VITE_ASSET__886ff8cd__"